import { render, staticRenderFns } from "./EventScriptParagraph.vue?vue&type=template&id=3a17b09c"
import script from "./EventScriptParagraph.vue?vue&type=script&lang=js"
export * from "./EventScriptParagraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports